export const version = "units/5.6.1";
//# sourceMappingURL=_version.js.map